import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const deActivateAllTemplates = async (domain: string, flowId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `flows/${flowId}/messages-templates/deactivate-all`,
        method: 'PUT',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}